import { Box, Container, Grid } from "@mui/material";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import {
  StyledGridContainer,
  StyledContent,
  StyledTitle,
} from "@Styled/Pages/Prefooter";

const Careers = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            Careers{" "}
          </StyledHeadingWithGradientunderline>
        </StyledGridContainer>
        <StyledTitle>General Application</StyledTitle>
        <StyledContent>
          {" "}
          Can’t find a career you’re looking for? We want to hear from you,
          please send your application to{" "}
          <a href="mailto: hr@econut.store" style={{ color: "#00844a" }}>
            hr@econut.store{" "}
          </a>
          .
        </StyledContent>
      </Container>
    </>
  );
};
export default Careers;
